import { _post } from "../Api";
import { toast } from "react-toastify";

export function updateMerchants(merchants, newData, oldValues, updatedKey = true) {
  let data = [];
  for (let i in merchants) {
    data.push({
      merchantId: merchants[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchants/update", data)
    .then((res) => {
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    });
}
